export const ACTION_TYPE_LABELS = {
    'whatsapp': 'WhatsApp',
    'whatsapp_api': 'WhatsApp (API)',
    'whatsapp-cloud': 'WhatsApp (API)',
    'sms': 'SMS',
    'rcs': 'RCS',
    'email': 'Email',
    'automation': 'Automação',
    'ai_basic': 'IA Básica',
    'ai_advanced': 'IA Avançada',
    'ai_gpt-5-mini': 'IA Avançada (GPT-5)',
    'ai_dataset_selection': 'Seleção por IA',
    'task': 'Tarefa',
    'task-ai': 'Tarefa com IA',
    'webhook': 'WebHook',
    'smart_insertion': 'Inserção Inteligente',
    'plugin_action': 'Ação de Plugin',
    'manual': 'Ajuste Manual',
    'removed': 'Ajuste Manual',
    'other': 'Outros'
};

export const ACTION_TYPE_I18N_MAP = {
    'whatsapp': 'balance-action_type_whatsapp',
    'whatsapp_api': 'balance-action_type_whatsapp_api',
    'whatsapp-cloud': 'balance-action_type_whatsapp_api',
    'sms': 'balance-action_type_sms',
    'rcs': 'balance-action_type_rcs',
    'email': 'balance-action_type_email',
    'automation': 'balance-action_type_automation',
    'ai': 'balance-action_type_ai',
    'ai_basic': 'balance-action_type_ai_basic',
    'ai_advanced': 'balance-action_type_ai_advanced',
    'ai_gpt-5-mini': 'balance-action_type_ai_gpt5',
    'ai_dataset_selection': 'balance-action_type_ai_selection',
    'task': 'balance-action_type_task',
    'task-ai': 'balance-action_type_task_ai',
    'webhook': 'balance-action_type_webhook',
    'smart_insertion': 'balance-action_type_smart_insertion',
    'plugin_action': 'balance-action_type_plugin',
    'manual': 'balance-action_type_manual',
    'removed': 'balance-action_type_manual',
    'other': 'balance-action_type_other',
};

export const ACTION_TYPE_COLORS_MAP = {
    'whatsapp': '#2AAA4C',             
    'whatsapp_api': '#2AAA4C',         
    'whatsapp-cloud': '#2AAA4C',       
    'sms': '#2970FF',
    'rcs': '#5B4DFF',                  
    'email': '#FDA712',               
    'automation': '#EE46BC',           
    'ai': '#875BF7',                   
    'ai_basic': '#875BF7',             
    'ai_advanced': '#7839EE',         
    'ai_gpt-5-mini': '#6927DA',        
    'ai_dataset_selection': '#A48AFB', 
    'task': '#F04438',                 
    'task-ai': '#F04438',              
    'webhook': '#17B26A',              
    'smart_insertion': '#DD2590',     
    'plugin_action': '#155EEF',        
    'manual': '#C56A09',               
    'removed': '#C56A09',              
    'other': '#9598A6',                
};

export const DYNAMIC_COLORS_POOL = [
    '#2AAA4C', 
    '#2970FF', 
    '#FDA712', 
    '#875BF7', 
    '#EE46BC', 
    '#2DBBDD', 
    '#F04438', 
    '#155EEF', 
    '#C56A09', 
    '#491C96', 
    '#C11574', 
    '#00542E', 
    '#FFDA71', 
    '#7FAAFF', 
    '#FAA7E0', 
    '#A48AFB',
];

export function getDynamicColor(index) {
    return DYNAMIC_COLORS_POOL[index % DYNAMIC_COLORS_POOL.length];
}

const localeMap = {
    'ptBr': 'pt-BR',
    'pt': 'pt-BR',
    'en': 'en-US',
    'es': 'es-ES'
};

export function formatNumber(value, decimals = 2, lang = 'ptBr') {
    const num = parseFloat(value) || 0;
    const locale = localeMap[lang] || 'pt-BR';
    return num.toLocaleString(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
}

export function formatPercent(value, lang = 'ptBr') {
    if (!value) return 0;
    const locale = localeMap[lang] || 'pt-BR';
    return value.toLocaleString(locale, {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
    });
}

export function formatActionType(type) {
    if (!type) return 'Outros';
    const normalizedType = type.toLowerCase().trim();
    return ACTION_TYPE_LABELS[normalizedType] || type;
}
